import axios from 'axios';
import React, { useState, useEffect } from 'react'
import './AddTheatre.css'
import BASE_URL from '../../constant';
import { useNavigate } from 'react-router-dom';


function AddTheatre() {

    const [theatreData, setTheatreData] = useState({
        name : "",
        facilities : "",
        location : "",
        pincode : '',
        city: "",
        rows : "",
        cols : "",
    });

    const navigate = useNavigate();
    const storedAdmin = JSON.parse(localStorage.getItem("adminData"));
    const [logStatus, setLogStatus] = useState(true);

    useEffect(()=>{
      if(!storedAdmin){
        setLogStatus(false)
        return
      }
    },[storedAdmin])

    const handleChange = (e)=>{
        const {name, value} = e.target;
        setTheatreData({
            ...theatreData,
            [name] : value
        })
  
    }
    const handleSubmit = (e)=>{
        e.preventDefault();

        if(!theatreData.name || !theatreData.facilities || !theatreData.location 
          || !theatreData.pincode || !theatreData.city || !theatreData.rows || !theatreData.cols){
            console.log("Missing information");
            return;
          }

        axios.post(`${BASE_URL}/bookmyshow/api/v1/theatre/`, theatreData)
        .then(res => {
            console.log(res.data);
            navigate("/admin");
        })
        .catch(err => console.error(err));

        
    }



  return (
    <div className="addmoviesCont">
      
    {(!logStatus) ? "Unauthorised access" : 
    <form className="form addtheatreForm"  method="post" encType="multipart/form-data">

        <div className="input-field">
          <span>Theater Name</span>
          <input required onChange={handleChange} name="name" value={theatreData.name} type="text" className="input" />
        </div>

        <div className="input-field">
          <span>Facilities</span>
          <input required placeholder='Food & Beverage, M-tickets, Prime Seats ...' onChange={handleChange} name="facilities" value={theatreData.facilities} type="text" className="input" />
        </div>
        
        
        <div className="heading">
            <i className='fa-solid fa-building'></i>&nbsp;
            Address
        </div>
        <div className="input-field">
          <span>Location</span>
          <input required placeholder='ABC, sector-123, xyz-Nagar' onChange={handleChange} name="location" value={theatreData.location} type="text" className="input" />
        </div>
     
        <div className="flex">
           <div className="input-field">
             <span>City</span>
             <input required onChange={handleChange} name="city" value={theatreData.city} type="text" className="input" />
           </div>
           <div className="input-field">
             <span>Area Pincode</span>
             <input required onChange={handleChange} name="pincode" value={theatreData.pincode} type="tel" className="input" />
           </div>
        </div>
        


        <div className="heading">
            <i className='fa-solid fa-chair'></i>&nbsp;
            Seating Arrangement
        </div>
        <div className="flex">
        <div className="input-field">
             <span>Rows in theatre</span>
             <input required onChange={handleChange} name="rows" value={theatreData.rows} type="tel" className="input" />
           </div>
           <div className="input-field">
             <span>Columns in theatre</span>
             <input required onChange={handleChange} name="cols" value={theatreData.cols} type="tel" className="input" />
           </div>
        </div>

      
        <div className="submitBtnContainer">
          <button className="submitBtn" onClick={handleSubmit} >
            Register Theatre
          </button>
        </div>
    </form>
}
    </div>
  )
}

export default AddTheatre
